import { Button } from "@inceptionbg/ui-components";
import clsx from "clsx";
import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../Context/AppContext";
import { InfoBox } from "../../Elements/Alert/InfoBox";

const CONSENT_DOCUMENT_URL =
  "https://erpg.eagrar.gov.rs/upload/Izjava_saglasnost_eAgrar_pravni_osnov.pdf";

interface Props {
  title: string;
  buttonLabel: string;
  onButtonClick: () => void;
  buttonDisabled?: boolean;
}

export const FarmConsentInfoBox: FC<Props> = ({
  title,
  buttonLabel,
  onButtonClick,
  buttonDisabled,
}) => {
  const { t } = useTranslation();
  const {
    screen: { isMobile },
  } = useContext(AppContext);

  return (
    <InfoBox
      title={title}
      className={clsx("dashboard-consent-banner", { "mx-5 l": !isMobile })}
      descEl={
        <div className="dashboard-consent-content">
          <p className="new-line">
            {t("DashboardConsentTextPrefix")}{" "}
            <a href={CONSENT_DOCUMENT_URL} target="_blank" rel="noreferrer">
              {t("DashboardConsentLinkText")}
            </a>{" "}
            {t("DashboardConsentTextSuffix")}
          </p>
          <Button
            label={buttonLabel}
            primary
            size="m"
            onClick={onButtonClick}
            disabled={buttonDisabled}
          />
        </div>
      }
    />
  );
};
